import styled from "styled-components"

export const Title = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  margin: 10px 0 5px;
`
